var _rect, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1444_39485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 101
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FF965D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1444_39485)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 100,
    height: 100,
    fill: "#E31D93"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.7081 38.3788C60.7081 44.2363 55.9139 48.9848 50 48.9848C44.0861 48.9848 39.292 44.2363 39.292 38.3788C39.292 32.5212 44.0861 27.7727 50 27.7727C55.9139 27.7727 60.7081 32.5212 60.7081 38.3788Z",
    fill: "#E31D93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1136 68.1768C30.1136 59.2509 37.0627 52.0151 45.6347 52.0151H54.3653C62.9374 52.0151 69.8864 59.2509 69.8864 68.1768C69.8864 70.9661 67.7148 73.2273 65.036 73.2273H34.964C32.2852 73.2273 30.1136 70.9661 30.1136 68.1768Z",
    fill: "#E31D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserBg);
export default __webpack_public_path__ + "static/media/icUserBg.ab8cb9f033be06d271c62c341428a011.svg";
export { ForwardRef as ReactComponent };